<template>
  <div class="m_t_60">
    <div class="t_a_c">
      <div class="f_w_600 f_s_40 c_000000d9">{{childModule.text}}</div>
    </div>
    <div class="flex j_c_c m_t_48">
      <div
        v-for="(item) in childModule.list"
        :key="item.text"
        class="pos_r flex j_c_c w_389 h_512 m_r_20 of_h"
      >
        <img :src="item.img" class="w_100p scale12" />
        <div class="t_a_c m_lr_auto pos_a top_100 w_100p c_fff m_t_30">
          <div class="f_s_16">{{item.text}}</div>
          <div class="visuallyhidden f_w_600 f_s_34 m_t_20">{{item.slogan}}</div>
          <div class="f_s_16 f_w_500 m_t_10" v-html="item.headline"></div>
          <div class="flex j_c_c m_t_20 f_s_12">
            <!-- <div class="b_r_20 cursor_p btn p_4 m_r_20">了解更多</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 附属产品介绍
 */
export default {
  name: "ChildModule",
  props: {
    childModule: {
      type: Object
    }
  }
};
</script>

<style>
.w_389 {
  width: 389px;
}
.h_512 {
  height: 512px;
}
</style>